import { tEngine } from "../../../i18n/engine";
import { t } from "../../../i18n";
import { CASE_LABEL, type CaseId, type WallResult } from "@tasduvar/engine";
import { Section } from "./common";

export function Steps({ result }: { result: WallResult }): JSX.Element {
  const groups: { title: string; steps: WallResult["trace"] }[] = [{ title: t("Geometri ve deprem parametreleri"), steps: result.trace.filter((s) => !s.caseId) }];
  for (const cid of Object.keys(result.cases) as CaseId[]) groups.push({ title: tEngine(CASE_LABEL[cid]), steps: result.trace.filter((s) => s.caseId === cid) });
  return (
    <Section id="steps" title={t("8. Hesap Adımları")}>
      {groups.filter((g) => g.steps.length).map((g) => (
        <div key={g.title}>
          <h3>{g.title}</h3>
          {g.steps.map((s) => (
            <div key={s.id} className="step">
              <div className="title">{tEngine(s.title)}{s.ref ? <span className="ref"> — {s.ref}</span> : null}</div>
              <div className="mono">{s.formula}</div>
              <div className="mono">{tEngine(s.substituted)}</div>
              <div className="mono">= {s.result} {s.unit}</div>
            </div>
          ))}
        </div>
      ))}
    </Section>
  );
}
